import React from 'react'
import _ from 'lodash'
import moment from 'moment-timezone'
import {
  Card,
  ContentSectionBlock,
  ButtonContainer,
  Button,
  FormInput,
  FormInputSelect,
  FormInputDateRange,
  Row,
  Col,
  Alert
} from 'camino-react'

import { cloudhelpPost } from 'Utilities/CloudHelp'

export default class ClientTicketBreakdownForm extends React.Component {
  constructor (props) {
    super(props)

    const { currentUser, clients } = this.props

    this.state = {
      fields: {
        tickets_reports_client_id: currentUser.calligo_employee ? null : clients[0].id,
        tickets_client_report_start_date: new Date(),
        tickets_client_report_end_date: new Date(),
        tickets_client_reports_open_ticket: 'created_month'
      },
      alert: {
        messages: []
      }
    }
  }

  handleInputChange = (fieldName, value) => {
    this.setState((prevState) => {
      const { fields } = prevState
      const newFields = Object.assign({}, fields, { [fieldName]: value })
      return (
        { fields: newFields }
      )
    })
  }

  handleDateRangeInputChange = (dates) => {
    this.handleInputChange('tickets_client_report_start_date', dates[0])
    this.handleInputChange('tickets_client_report_end_date', dates[1])
  }

  submitForm = () => {
    const { fields } = this.state
    const {
      tickets_reports_client_id,
      tickets_client_report_start_date,
      tickets_client_report_end_date,
      tickets_client_reports_open_ticket
    } = fields

    const clientIdInvalid = _.isNil(tickets_reports_client_id)
    const startDateInvalid = moment(tickets_client_report_start_date).isAfter(tickets_client_report_end_date)
    const openTicketsInvalid = _.isNil(tickets_client_reports_open_ticket)

    const errorMessages = []

    clientIdInvalid && errorMessages.push('Please choose a client.')
    startDateInvalid && errorMessages.push('Start date must be before end date.')
    openTicketsInvalid && errorMessages.push('Must select from Live Count or Created in this Time Period')

    if (_.some(errorMessages)) {
      this.setState({ alert: { type: 'error', text: errorMessages.join(' ') } })

      return
    }

    const { clientTicketReportPath } = this.props

    const postData = {
      tickets_reports_client_id,
      tickets_client_report_start_date,
      tickets_client_report_end_date,
      tickets_client_reports_open_ticket
    }

    cloudhelpPost(clientTicketReportPath, postData)
      .then((response) => {
        window.open(response.data.redirect_url, '_blank')
      })
  }

  render () {
    const { clients } = this.props
    const { fields, alert } = this.state
    const { messages: alertMessages } = alert
    const {
      tickets_reports_client_id: clientID,
      tickets_client_report_start_date: startDate,
      tickets_client_report_end_date: endDate,
      tickets_client_reports_open_ticket: openTicket
    } = fields

    const valueForSelect = (options, field) => (_.find(options, ({ value }) => value === field))
    const clientOptions = _.map(
      _.sortBy(clients, 'full_name'), client => ({
        value: client.id,
        label: client.full_name
      })
    )
    const reportFilterOptions = [
      { value: 'created_month', label: 'Created in this time period' },
      { value: 'open_live_count', label: 'Live Count' }
    ]

    return (
      <Row>
        <Col width={12}>
          <Card padding={false} allowOverflow>
            <ContentSectionBlock title="Generate Client Report">
              {_.some(alertMessages) && (
                <Alert>
                  <span>
                    {alertMessages}
                  </span>
                </Alert>
              )}

              <FormInput label="Client">
                <FormInputSelect
                  placeholder="Select Client"
                  value={valueForSelect(clientOptions, clientID)}
                  options={clientOptions}
                  onValue={value => (this.handleInputChange('tickets_reports_client_id', value))}
                />
              </FormInput>

              <FormInput label="Date Range">
                <FormInputDateRange
                  value={[startDate, endDate]}
                  onValue={value => (this.handleDateRangeInputChange(value))}
                />
              </FormInput>

              <FormInput label="Open Tickets">
                <FormInputSelect
                  value={valueForSelect(reportFilterOptions, openTicket)}
                  options={reportFilterOptions}
                  onValue={value => (this.handleInputChange('tickets_client_reports_open_ticket', value))}
                />
              </FormInput>

              <ButtonContainer>
                <Button onClick={this.submitForm}>
                  Generate
                </Button>
              </ButtonContainer>

            </ContentSectionBlock>
          </Card>
        </Col>
      </Row>
    )
  }
}
